/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { createPortal } from 'react-dom';

import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';
import { element, string, object } from 'prop-types';

const styles = () => ({
    loaderBackground: {
        '&::before': {
            width: '100%',
            height: '300%',
            content: '""',
            position: 'absolute',
            zIndex: '10000',
            backgroundColor: 'rgba(0,0,0,0.5)',
        },
    },
    spinner: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        zIndex: '10001',
    },
    bottom: {
        color: '#fff',
    },
});

const GraphqlLoadingDiv = ({ target, classes, elementToRender }) => {
    if (typeof document !== 'undefined') {
        const portalRoot = target
            ? document.getElementById(target)
            : document.getElementById('fullPageLoadingDiv');
        const loaderDiv = (
            <div className={classes.loaderBackground}>
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={70}
                    thickness={5}
                    classes={{ root: classes.spinner }}
                    className={classes.bottom}
                />
                <CircularProgress
                    classes={{ root: classes.spinner }}
                    size={70}
                    thickness={5}
                />
            </div>
        );
        if (!portalRoot) {
            return null;
        }
        return createPortal(
            elementToRender || loaderDiv,
            portalRoot,
        );
    }

    return null;
};

GraphqlLoadingDiv.propTypes = {
    target: string,
    classes: object.isRequired,
    elementToRender: element,
};

GraphqlLoadingDiv.defaultProps = {
    elementToRender: undefined,
    target: '',
};

export default withStyles(styles)(GraphqlLoadingDiv);
